import { FetchData } from './utils/fetchData'
import Preloader from './preloader'

export class RemoveFromFavorites {
    activeButton = null;

    static selectors = {
        button: '[data-js-remove-from-fav]',
        modalRemoveButton: '[data-js-modal-remove]',
        removeOnSuccess: '[data-js-remove]',
    }

    constructor() {
        this.buttons = document.querySelectorAll(RemoveFromFavorites.selectors.button);
        this.modalRemoveButton = document.querySelector(RemoveFromFavorites.selectors.modalRemoveButton);

        if (this.buttons.length === 0) {
            return;
        }

        this.bindEvents()
    }

    remove = async (button) => {
        if (!this.activeButton) {
            return;
        }

        this.removeOnSuccessNode = this.activeButton.closest(RemoveFromFavorites.selectors.removeOnSuccess);
        const ajaxUrl = this.modalRemoveButton.dataset.jsAjaxUrl;
        const itemId = this.activeButton.dataset.jsRemoveFromFav;
        const response = await FetchData.postData({ data: itemId }, ajaxUrl);

        if (response?.success) {
            this.removeOnSuccessNode.remove();
        }

        Preloader.hide()
    }

    saveItemId = (evt) => {
        this.activeButton = evt.currentTarget;
    }

    bindEvents() {
        this.buttons.forEach((btn) => {
            btn.addEventListener('click', this.saveItemId)
        })

        this.modalRemoveButton.addEventListener('click', this.remove)
    }
}
